import React from "react";
import Button, {
  ButtonAccessability,
} from "components/Elements/Button/Button.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Image from "components/Elements/Image/Image.tsx";
import { useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useToasts } from "react-toast-notifications";
import { useModal } from "contexts/modalContext/modalContext.js";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";
import config from "config";

import "./LogoutModal.scss";

const radioOptionsEnum = {
  // option value : textKey
  current: "this-device",
  all: "all-devices",
};

const RadioSection = ({ setLogoutFrom, logoutFrom }) => {
  const { getTextByKey } = useContent();
  return (
    <div className="selection-container">
      {Object.entries(radioOptionsEnum).map(([key, textKey]) => {
        return (
          <ButtonAccessability
            buttonClassName="radio-elem"
            onClick={() => {
              setLogoutFrom(key);
            }}
          >
            <Image
              name={logoutFrom === key ? "radio-checked" : "radio-unchecked"}
              hideTitle
            />
            {getTextByKey(textKey)}
          </ButtonAccessability>
        );
      })}
    </div>
  );
};

const LogoutModal = () => {
  const { getTextByKey, getHtmlByKey, getPath } = useContent();

  const { logout } = useUser();

  const { addToast } = useToasts();

  const { closeModal } = useModal();

  const [logoutFrom, setLogoutFrom] = useState("current");

  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    // api call to set up new logout date UpdatePasswordDate post with userEmail
    if (logoutFrom === "all") {
      await apiRequest("Users", `UpdatePasswordDate`, {}, "POST");
    }
    await logout();
    setLoading(false);
    if (checkCurrDomainIsOrgDomain()) {
      window.location.href = `${config.baseurl}${getPath()}login`;
    }
    closeModal();
    addToast(getTextByKey("logout-success"), {
      appearance: "success",
    });
  };

  return (
    <div className="logout-modal">
      {loading ? (
        <div className="contacts-loading-container">
          <Image name="preloader" ext="gif" alt="" title="" />
        </div>
      ) : (
        <>
          <div className="logout-title">{getHtmlByKey("logout-title")}</div>
          <div className="logout-text">{getHtmlByKey("logout-text")}</div>
          <RadioSection logoutFrom={logoutFrom} setLogoutFrom={setLogoutFrom} />
          <div className="button-container">
            <Button onClick={() => closeModal()} medium blank>
              {getTextByKey("cancel")}
            </Button>
            <Button onClick={handleLogout} medium>
              {getTextByKey("logout")}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default LogoutModal;
